export interface PossibleTypesResultData {
	possibleTypes: {
		[key: string]: string[];
	};
}
const result: PossibleTypesResultData = {
	possibleTypes: {
		AddTracksToPartnerPlaylistResult: [
			'AddTracksToPartnerPlaylistError',
			'AddTracksToPartnerPlaylistOutput',
		],
		ArtistHighlightContent: ['Album', 'Playlist', 'Podcast', 'PodcastEpisode'],
		Asset: ['FormattedImage', 'Video'],
		AudiobookContributor: ['Artist'],
		CardTemplate: [
			'Chapter',
			'Cover',
			'Duo',
			'Page',
			'Poster',
			'Story',
			'Summary',
			'Top',
		],
		ConcertAttendee: ['Artist', 'GenericConcertArtist'],
		Contributor: ['Artist'],
		DeezerUrl: ['Url'],
		DownloadableContent: ['Album', 'Playlist', 'SmartTracklist'],
		FlowMood: ['Flow', 'FlowConfig'],
		GridFullSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotedContent',
			'PromotionalVideo',
			'SmartTracklist',
			'Track',
		],
		GridOneLineSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotedContent',
			'PromotionalVideo',
			'SmartTracklist',
			'Track',
		],
		GridTwoLinesSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotedContent',
			'PromotionalVideo',
			'SmartTracklist',
			'Track',
		],
		HorizontalGridSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotedContent',
			'PromotionalVideo',
			'SmartTracklist',
			'Track',
		],
		HorizontalListSectionContentItem: ['Track'],
		Image: ['Illustration', 'Picture'],
		InstantSearchArtistBestResultRelatedContent: [
			'InstantSearchArtistBestResultRelatedContentNewRelease',
			'InstantSearchArtistBestResultRelatedContentRelevantAlbum',
			'InstantSearchArtistBestResultRelatedContentTopTracks',
		],
		InstantSearchBestResult: [
			'InstantSearchAlbumBestResult',
			'InstantSearchArtistBestResult',
			'InstantSearchLivestreamBestResult',
			'InstantSearchPlaylistBestResult',
			'InstantSearchPodcastBestResult',
			'InstantSearchPodcastEpisodeBestResult',
			'InstantSearchTrackBestResult',
		],
		InstantSearchPodcastBestResultRelatedContent: [
			'InstantSearchPodcastBestResultRelatedContentLatestEpisode',
			'InstantSearchPodcastBestResultRelatedContentOngoingEpisode',
		],
		InstantSearchTopResultContent: [
			'Album',
			'Artist',
			'Livestream',
			'Playlist',
			'Podcast',
			'PodcastEpisode',
			'Track',
		],
		ItemHighlightSectionContentItem: ['Mix'],
		LargeCardSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotedContent',
			'PromotionalVideo',
			'SmartTracklist',
		],
		ListSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PodcastEpisode',
			'PromotionalVideo',
			'Track',
		],
		LiveEventContributor: ['Artist'],
		LongCardHorizontalGridSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotionalVideo',
		],
		MadeForMe: ['Flow', 'SmartTracklist'],
		MiniBannerSectionContentItem: ['PromotedContent'],
		MusicTogetherCreateGroupResult: [
			'MusicTogetherCreateGroupError',
			'MusicTogetherCreateGroupOutput',
		],
		MusicTogetherJoinGroupResult: [
			'MusicTogetherJoinGroupError',
			'MusicTogetherJoinGroupOutput',
		],
		MusicTogetherLeaveGroupResult: [
			'MusicTogetherLeaveGroupError',
			'MusicTogetherLeaveGroupOutput',
		],
		MusicTogetherRefreshSuggestedTracklistResult: [
			'MusicTogetherRefreshSuggestedTracklistError',
			'MusicTogetherRefreshSuggestedTracklistOutput',
		],
		MusicTogetherUpdateGroupSettingsResult: [
			'MusicTogetherUpdateGroupSettingsError',
			'MusicTogetherUpdateGroupSettingsOutput',
		],
		Node: [
			'Album',
			'Artist',
			'ArtistConcert',
			'Audiobook',
			'AudiobookChapter',
			'Channel',
			'Flow',
			'FlowConfig',
			'FlowWheel',
			'LiveEvent',
			'LiveVideoStream',
			'Livestream',
			'Lyrics',
			'Mix',
			'MusicTogetherGroup',
			'MusicTogetherGroupMember',
			'Playlist',
			'Podcast',
			'PodcastEpisode',
			'PrivateUser',
			'PromotedContent',
			'PromotionalVideo',
			'QueueChunk',
			'SmartTracklist',
			'Track',
			'User',
			'VideoStream',
		],
		ParticipateToContestResult: [
			'ParticipateToContestError',
			'ParticipateToContestOutput',
		],
		PatchQueueStateResult: ['PatchQueueStateError', 'PatchQueueStateOutput'],
		PlaylistAddTracksResult: [
			'PlaylistAddTracksError',
			'PlaylistAddTracksOutput',
		],
		PlaylistFromSmartTracklistCreateMutationResult: [
			'PlaylistFromSmartTracklistCreateMutationError',
			'PlaylistFromSmartTracklistCreateMutationOutput',
		],
		PrivateUserRawFavorite: [
			'PrivateUserRawAlbumFavorite',
			'PrivateUserRawArtistFavorite',
			'PrivateUserRawPlaylistFavorite',
			'PrivateUserRawPodcastFavorite',
			'PrivateUserRawTrackFavorite',
		],
		PromotableContent: [
			'Album',
			'Artist',
			'BlindTest',
			'Channel',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PodcastEpisode',
			'SmartTracklist',
			'Track',
		],
		PushQueueStateResult: ['PushQueueStateError', 'PushQueueStateOutput'],
		RecentlyPlayedContent: [
			'Album',
			'Artist',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
		],
		ReportCatalogIssueMutationResult: [
			'ReportCatalogIssueMutationError',
			'ReportCatalogIssueMutationOutput',
		],
		SearchHistorySuccessResult: [
			'Album',
			'Artist',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PodcastEpisode',
			'Track',
		],
		SearchMixedResult: [
			'Album',
			'Artist',
			'Channel',
			'FlowConfig',
			'Livestream',
			'Playlist',
			'Podcast',
			'PodcastEpisode',
			'Track',
			'User',
		],
		SearchTopResultContent: [
			'Album',
			'Artist',
			'Livestream',
			'Playlist',
			'Podcast',
			'PodcastEpisode',
			'Track',
		],
		Section: [
			'AdSection',
			'BrazeSection',
			'ConversionSection',
			'GridFullSection',
			'GridOneLineSection',
			'GridTwoLinesSection',
			'HorizontalGridSection',
			'HorizontalListSection',
			'InformativeSection',
			'ItemHighlightSection',
			'LargeCardSection',
			'ListSection',
			'LongCardHorizontalGridSection',
			'MiniBannerSection',
			'OnboardingSection',
			'SlideshowSection',
			'SmallHorizontalGridSection',
		],
		SlideshowSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotedContent',
			'PromotionalVideo',
			'SmartTracklist',
		],
		SmallHorizontalGridSectionContentItem: [
			'Album',
			'Artist',
			'Channel',
			'Flow',
			'Livestream',
			'Mix',
			'Playlist',
			'Podcast',
			'PromotedContent',
		],
		VideoContributor: ['Artist'],
	},
};
export default result;
